import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';
import { theme } from 'twin.macro';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { AuthGuard } from '@restworld/feature-authentication';
import { Spinner } from '@restworld/ui-ds';

import NextNProgress from 'nextjs-progressbar';

import nextI18NextConfig from '../next-i18next.config';
import GlobalStyles from '../styles/GlobalStyles';
import 'mapbox-gl/dist/mapbox-gl.css';
import '../styles/globals.css';
import ErrorBoundaryWrapper from '../components/error-boundary';
import { MainContextWrapper } from '../context';
import GuardLoaderComponent from '../utility-components/guard-loader';

const TestEnvironmentFrame: React.FunctionComponent = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      {/* Yellow border frame around the entire viewport */}
      <div tw="fixed inset-0 pointer-events-none z-[9999]" style={{ border: '2px solid #eab308' }} />
      {/* TEST badge - top right */}
      <div tw="fixed top-2 right-2 z-[9999]">
        <div
          tw="relative cursor-pointer"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <span tw="inline-block px-1.5 py-0.5 bg-yellow-400 text-yellow-900 text-[10px] font-bold rounded leading-none tracking-wide">
            TEST
          </span>
          {showTooltip && (
            <div tw="absolute right-0 top-full mt-1 px-2 py-1 bg-yellow-400 text-yellow-900 text-xs font-semibold rounded shadow whitespace-nowrap">
              Ambiente di test
            </div>
          )}
        </div>
      </div>
    </>
  );
};

function CustomApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      // eslint-disable-next-line no-console
      console.trace('Route change trace:', url);
    };
    router.events.on('routeChangeStart', handleRouteChangeStart);
    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [router.events]);
  return (
    <>
      <GlobalStyles />
      <ErrorBoundaryWrapper>
        <MainContextWrapper>
          {process.env.NEXT_PUBLIC_APP_ENV !== 'production' && <TestEnvironmentFrame />}
          <GuardLoaderComponent>
            <NextNProgress
              color={theme`colors.primary.500`}
              showOnShallow
              options={{
                showSpinner: false,
              }}
            />
          </GuardLoaderComponent>
          <AuthGuard loader={<Spinner size="lg" color="primary" />}>
            <Component {...pageProps} />
          </AuthGuard>
        </MainContextWrapper>
      </ErrorBoundaryWrapper>
    </>
  );
}

export default appWithTranslation(CustomApp, nextI18NextConfig);
